/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserToken,
    ReadOnlyUserTokenFromJSON,
    ReadOnlyUserTokenFromJSONTyped,
    ReadOnlyUserTokenToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20045
 */
export interface InlineResponse20045 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20045
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20045
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20045
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserToken>}
     * @memberof InlineResponse20045
     */
    results: Array<ReadOnlyUserToken>;
}

export function InlineResponse20045FromJSON(json: any): InlineResponse20045 {
    return InlineResponse20045FromJSONTyped(json, false);
}

export function InlineResponse20045FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20045 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserTokenFromJSON)),
    };
}

export function InlineResponse20045ToJSON(value?: InlineResponse20045 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserTokenToJSON)),
    };
}


